export const dataPtBr = {
  lang: "pt-br",
  header: {
    texts: [
      { name: "Sobre Mim", linkTo: "about-me" },
      { name: "Projetos", linkTo: "projects" },
      { name: "Contato", linkTo: "contact-me" },
    ],
  },
  banner: {
    subtitle: ["Desenvolvedor Web", "Front-End"],
    buttons: ["Contate-Me", "Projetos"],
    scroll: "Role para baixo",
  },
  section1: {
    title: "Sobre mim",
    subtitle: "Olá, me chamo Lucas Gabriel dos Santos",
    text: "Sou um amante da tecnologia e de arte.\n\nMe formei no ensino médio integrado ao curso técnico de Informática em 2020, desde então criei um enorme interesse na área da tecnologia. \n\nEm 2022 me formei no Instituto PROA que foi uma ótima experiência, onde eu pude aprender conceitos importantes e mais aprofundados sobre programação, sendo eles: HTML; CSS; JavaScript; React; JAVA; SCRUM; Git e GitHub. Estou me aperfeiçoando em Front-End, utilizando, TypeScript, ReactJs e NextJs. No futuro pretendo me especializar na área de desenvolvimento web.\n\nAlém disso, sou autodidata nos estudos sobre edição de fotos e vídeos, assim me impulsiono criativamente para a realização de projetos.",
    itemsExp: [
      { id: 1, description: "Anos de experiência" },
      { id: 5, description: "Cursos completos" },
      { id: 5, description: "Projetos" },
    ],
  },
  section2: {
    title: "Veja meus projetos",
    subtitle:
      "Aqui estão alguns dos meus projetos realizados através das minhas experiências",
    button: "Ver todos",
    buttons: "Ver mais sobre",
  },
  section3: {
    title: "Habilidades",
    subtitle:
      "Sou um profissional que está sempre atento às novas tendências do ecossistema React, explorando bibliotecas complementares. Além das competências técnicas, minha capacidade de trabalhar em equipe e comunicar-se eficazmente é crucial, permitindo que eu transforme requisitos em soluções criativas e focadas na experiência do usuário. O amor pela tecnologia e a curiosidade em explorar novas ferramentas me impulsionam em buscar a excelência em cada projeto, criando interfaces intuitivas e responsivas atendendo expectativas dos usuários. Além de ter um ótimo conhecimento de design de sites e edição de imagens utilizando Figma e Photoshop.",
  },
  section4: {
    title: "FALE COMIGO",
    email: "E-mail",
    subject: "Assunto",
    message: "Escreva sua mensagem...",
    button: "Enviar",
    text: "Meus contatos",
  },
  footer: {
    texts: [
      { name: "Sobre Mim", linkTo: "about-me" },
      { name: "Projetos", linkTo: "projects" },
      { name: "Contato", linkTo: "contact-me" },
    ],
    rights:
      "Desenvolvido por lucasgsantos1727@gmail.com \n\n 2024 © Todos os direitos reservados.",
  },
  projectsPage: {
    title: "Todos os projetos",
    subtitle:
      "Todos os projetos que foram realizados até o momento, clique em cada um deles para ter mais detalhes sobre cada projeto.",
  },
  projectPage: {
    title: "DESCRIÇÃO",
    subtitle: "TECNOLOGIAS UTILIZADAS",
  },
};

export const dataEn = {
  lang: "en-us",
  header: {
    texts: [
      { name: "About Me", linkTo: "about-me" },
      { name: "Projects", linkTo: "projects" },
      { name: "Contact", linkTo: "contact-me" },
    ],
  },
  banner: {
    subtitle: ["Web Developer", "Front-End"],
    buttons: ["Contact Me", "Projects"],
    scroll: "Scroll down",
  },
  section1: {
    title: "About Me",
    subtitle: "Hello, my name is Lucas Gabriel dos Santos",
    text: "I am a technology and art enthusiast. I graduated from high school with an integrated technical course in Computer Science in 2020, and since then, I have developed a strong interest in the field of technology. In 2022, I graduated from the PROA Institute, which was a great experience where I was able to learn important and more in-depth concepts about programming, such as: HTML; CSS; JavaScript; React; JAVA; SCRUM; Git, and GitHub. I am currently refining my skills in Front-End development, using TypeScript, ReactJs, and NextJs. In the future, I plan to specialize in web development. Additionally, I am self-taught in photo and video editing, which fuels my creativity in completing projects.",
    itemsExp: [
      { id: 1, description: "Years of experience" },
      { id: 5, description: "Completed courses" },
      { id: 5, description: "Projects" },
    ],
  },
  section2: {
    title: "See My Projects",
    subtitle: "Here are some of my projects completed through my experiences",
    button: "View All",
    buttons: "Learn More About",
  },
  section3: {
    title: "Skills",
    subtitle:
      "I am a professional who is always attentive to the new trends in the React ecosystem, exploring complementary libraries. Besides technical skills, my ability to work in a team and communicate effectively is crucial, allowing me to transform requirements into creative solutions focused on user experience. My love for technology and curiosity to explore new tools drive me to seek excellence in every project, creating intuitive and responsive interfaces that meet users' expectations. I also have great knowledge of website design and image editing using Figma and Photoshop.",
  },
  section4: {
    title: "CONTACT ME",
    email: "E-mail",
    subject: "Subject",
    message: "Write your message...",
    button: "Send",
    text: "My contacts",
  },
  footer: {
    texts: [
      { name: "About Me", linkTo: "about-me" },
      { name: "Projects", linkTo: "projects" },
      { name: "Contact", linkTo: "contact-me" },
    ],
    rights:
      "Developed by lucasgsantos1727@gmail.com \n\n 2024 © All rights reserved.",
  },
  projectsPage: {
    title: "All Projects",
    subtitle:
      "All the projects that have been completed so far, click on each of them for more details about each project.",
  },
  projectPage: {
    title: "DESCRIPTION",
    subtitle: "TECHNOLOGIES USED",
  },
};
